import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedService } from '../../../../Services/shared.service';
import * as faceapi from 'face-api.js';

@Component({
  selector: 'app-verification',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './verification.component.html',
  styleUrl: './verification.component.css'
})
export class VerificationComponent {

  @ViewChild('CameraId') _camera!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas') _canvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('frame') _frame!: ElementRef<HTMLDivElement>;
  PREP_UserInfo: any = null;
  capturedImage: string | null = null;
  faceCount: any = null;
  msg: any = null;
  isShowCamera: any = false;

  constructor(
    private _svc: SharedService
  ) {
    this._svc.get_Login_Status().subscribe(x => {
      this.PREP_UserInfo = x;

    })
  }


  
  openCamera(): void {
    this.isShowCamera = true
    this._svc.openCamera(this._camera);
  }

  async captureImage() {
  
    const canvas = this._canvas.nativeElement;
    const video = this._camera.nativeElement;
    const context = canvas.getContext('2d');

    if (context) {
      
      
      const top = this._frame.nativeElement.offsetTop;
      const left = this._frame.nativeElement.offsetLeft;
      const height = this._frame.nativeElement.offsetHeight;
      const width = this._frame.nativeElement.offsetWidth;

      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = video.videoWidth;
      tempCanvas.height = video.videoHeight;
      const tempCtx = tempCanvas.getContext('2d');
      tempCtx?.drawImage(video, 0, 0, tempCanvas.width, tempCanvas.height);


      // Crop from original size to match frame

      const cropX = left * (video.videoWidth / video.clientWidth);
      const cropY = top * (video.videoHeight / video.clientHeight);
      const cropWidth = width * (video.videoWidth / video.clientWidth);
      const cropHeight = height * (video.videoHeight / video.clientHeight);

      context.drawImage(tempCanvas, cropX, cropY, cropWidth, cropHeight, 0, 0, canvas.width, canvas.height);

      const detections = await faceapi.detectAllFaces(
        this._canvas.nativeElement,
        new faceapi.SsdMobilenetv1Options()
      );
      this.msg = "";
      if (detections.length == 1)
        this.capturedImage = canvas.toDataURL('image/png'); // base64 image
      else {
        this.msg = "Make sure you're visible in the camera frame.";
        this.capturedImage = null;
      }
    }
  }
  ngOnDestroy(): void {
    this.isShowCamera = false;
    this._svc.closeCamera();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this._svc.loadModels();
    }, 100);
  }

  Upload() {
    this._svc.POST({ profilePic: this.capturedImage }, "/account/UploadProfile").subscribe(res => {
      this._svc.Notification(res.result, res.message)
      
      if (res.result == "success") {
        this.PREP_UserInfo.profilePic = this.capturedImage;
        localStorage.setItem('PREP_UserInfo', JSON.stringify({ ...this.PREP_UserInfo, loginDate: new Date().toLocaleDateString() }));
        this._svc.get_Login_Status();
        this.ngOnDestroy();
      }
    });
  }

}
